import { api } from './api';

/**
 * Fetches all forecast detail data for P&L report in a single efficient query
 * @param {Object} params - Query parameters
 * @param {number} params.orgId - Organization ID
 * @param {number} params.locationId - Location ID
 * @param {number} params.year - Year
 * @returns {Promise<Array>} Array of forecast detail records for all accounts
 */
export const getForecastPnLData = async ({ orgId, locationId, year }) => {
  try {
    const response = await api.get('/forecastPnL', {
      params: { orgId, locationId, year }
    });
    return response.data;
  } catch (error) {
    console.error('Error fetching forecast P&L data:', error);
    if (error.response) {
      console.error('Error response:', error.response.data);
      console.error('Error status:', error.response.status);
    }
    throw error;
  }
};

/**
 * Fetches forecast data using the V2 API with pre-calculated values
 * V2 returns same flat format as V1, but with calculatedForecastAmount added
 * @param {Object} params - Query parameters
 * @param {number} params.orgId - Organization ID
 * @param {number} params.locationId - Location ID
 * @param {number} params.year - Year
 * @returns {Promise<Array>} Array of forecast records with pre-calculated values
 */
export const getForecastPnLDataV2 = async ({ orgId, locationId, year }) => {
  try {
    const response = await api.get('/forecastV2', {
      params: { orgId, locationId, year }
    });
    // V2 now returns data in same flat format as V1, no transformation needed
    return response.data;
  } catch (error) {
    console.error('Error fetching forecast V2 data:', error);
    if (error.response) {
      console.error('Error response:', error.response.data);
      console.error('Error status:', error.response.status);
    }
    throw error;
  }
};
